const OnboardingImage = ({ url, caption }: IMatConfigurationImageProperty) => {
  return (
    <div className="mb-4 flex flex-col items-center">
      <img src={url} alt={caption} className="max-w-full" />
      {caption && (
        <p className="mt-2 text-center text-sm text-gray-600">{caption}</p>
      )}
    </div>
  );
};

export default OnboardingImage;
